import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-liste-validation',
  templateUrl: './liste-validation.component.html',
  styleUrls: ['./liste-validation.component.css']
})
export class ListeValidationComponent implements OnInit {

  attente : any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "en attente de validation",
      "duree" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur" : 1256,
      "etat" : "en attente de validation",
      "duree" : "16:00:00"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur" : 1254,
      "etat" : "en attente de validation",
      "duree" : "15:00:00",
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "en attente de validation",
      "duree" : "15:00:00"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "en attente de validation",
      "duree" : "15:00:00"
    },
  ];
  attenteCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur', header: 'Matricule OP'},
    {field: 'etat', header: 'Etat'},
    {field: 'duree', header: 'Durée de l\'attente'}
  ]

  valide: any[] = [
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Validé",
      "validation" : "26/06/2020 15:35:00"
    },
    {
      "id" : 1,
      "type" : "R",
      "complexite" : "complexe",
      "ptl" : 'Janne Doe',
      "operateur" : 1256,
      "etat" : "Validé",
      "validation" : "26/06/2020 16:00:00"
    },
    {
      "id" : 1,
      "type" : "R1",
      "complexite" : "normal",
      "ptl" : 'Baby Doe',
      "operateur" : 1254,
      "etat" : "Validé",
      "validation" : "26/06/2020 15:00:00",
    },
    {
      "id" : 1,
      "type" : "initial",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Validé",
      "validation" : "26/06/2020 15:00:00"
    },
    {
      "id" : 1,
      "type" : "R2",
      "complexite" : "normal",
      "ptl" : 'John Doe',
      "operateur" : 1254,
      "etat" : "Validé",
      "validation" : "26/06/2020 15:00:00"
    },
  ];

  valideCols: any[] = [
    {field: 'type', header: 'Type'},
    {field: 'complexite', header: 'Complexité'},
    {field: 'ptl', header: 'PTL'},
    {field: 'operateur', header: 'Matricule OP'},
    {field: 'etat', header: 'Etat'},
    {field: 'validation', header: 'Date de la validation'}
  ]
  constructor() { }

  ngOnInit(): void {
  }

}
